import { useEffect } from 'react';

import { useChatContext } from '../../../context/ChatContext';

import type { DefaultBeloChatGenerics } from '../../../types/types';

export const useConnectionRecoveredListener = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  forceUpdate?: () => void,
) => {
  const { client } = useChatContext<BeloChatGenerics>('useConnectionRecoveredListener');

  useEffect(() => {
    const handleEvent = () => {
      if (forceUpdate) {
        forceUpdate();
      }
    };

    client.on('connection.recovered', handleEvent);

    return () => {
      client.off('connection.recovered', handleEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
